import { render, staticRenderFns } from "./setup_login_form.vue?vue&type=template&id=ae083330"
import script from "./setup_login_form.vue?vue&type=script&lang=js"
export * from "./setup_login_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports